/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useEffect, useState, useRef } from 'react';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, Resize, ForeignKey,
} from '@syncfusion/ej2-react-grids';
import { Query } from '@syncfusion/ej2-data';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';

// import axios from 'axios';
import { Header } from '.';
// import { Methods } from '../pages/Methods';

import '../pages/Zackat.css';

const OTA = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=ota');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { zRenderMode, isMobile, boss } = useStateContext();

  const toolbarOptions = ['Search', 'Add', 'Edit', 'Delete'];
  const { REACT_APP_API_ENDPOINT } = process.env;
  const selectionSettings = { mode: 'Row', type: 'Single' };
  const valuerules = { required: true };
  let dialogInstance;
  function dialogClick(f, hdr, content, e) {
    const ok = null;
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }

  // const { loading, data } = Methods('otas', 'GET', '') || {};
  const [data, setData] = useState([]);
  const [otas, setOtas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(new Date().getTime());
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/otas?${query}&status=${boss}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      setData(mydata);
      setOtas(mydata.ota);
      setLoading(false);
    };
    dataFetch();
  }, [reload]);

  const fmtData = [
    { value: 'BIN', id: 'bin' },
  ];
  const statusData = [
    { value: 'Active', id: 'active' },
    { value: 'Beta', id: 'beta' },
    { value: 'Test', id: 'test' },
    { value: 'Inactive', id: 'inactive' },
    { value: 'Deprecated', id: 'deprecated' },
  ];
  const orgData = [];
  const start = (e) => {
    const device = prompt('Notify device of OTA?', '');
    const message = 'fota';
    const b = { device };
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
      })
      .catch(() => {
      });
  };
  function handleChange(e) {
    let upData = null;
    for (let idx = 0; idx < data.ota.length; idx += 1) {
      if (data.ota[idx]._id === e.target.id) {
        upData = data.ota[idx];
        break;
      }
    }
    const filedata = new FormData();
    const imagedata = e.target.files[0];
    filedata.append('userfile', imagedata);
    if (upData !== null) {
      filedata.append('_id', upData._id);
      filedata.append('fileName', e.target.files[0].name);
    } else {
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/otaup`, {
      method: 'POST',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
      },
      body: filedata,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        data.ota.filesid = responseJson._id;
        window.location.reload();
        // setReload(new Date().getTime());
      })
      .catch(() => {
        dialogClick('na', 'OTA Upload', 'An error has occured during Insert!', null);
      });
  }
  function removeOTA(e) {
    let removeData = null;
    for (let idx = 0; idx < data.ota.length; idx += 1) {
      if (data.ota[idx].filesid === e.target.id) {
        removeData = data.ota[idx];
        break;
      }
    }
    const orgs = [];
    const result = data.ota.find((element) => element.filesid === e.target.id);
    if (result) {
      data.organization.forEach((o) => {
        if (o.ota === result._id) {
          orgs.push(o.title);
        }
      });
    }
    if (orgs.length > 0) {
      DialogUtility.alert(`${removeData.name} is being used by ${orgs}`);
      return;
    }
    if (removeData == null || confirm(`Remove OTA file for ${removeData.name}?`) === false) {
      return;
    }
    if (removeData !== null) {
      fetch(`${REACT_APP_API_ENDPOINT}/otaup`, {
        method: 'DELETE',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(removeData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          // window.location.reload();
          setReload(new Date().getTime());
        })
        .catch(() => {
          dialogClick('na', 'OTA Upload', 'An error has occured during Delete!', null);
        });
    }
  }
  const gridOTAProfile = (props) => (
    <div className={`flex items-center gap-2 center 
      ${((props.filesid)
    ) ? 'e-background-colorgreen' : ''}`}
    >
      {!props.filesid
        ? <input type="file" name="userfile" id={props._id} onChange={handleChange} />
        : (
          <div>
            <button
              className="zackatcolor"
              name="remove"
              type="button"
              id={props.filesid}
              title={props.filesid}
              onClick={removeOTA}
            >
              🗑 OTA
            </button>
          </div>
        )}
    </div>
  );
  const gridOTAHeader = () => (
    <div>
      <pre>Media</pre>
    </div>
  );
  const otaTemplate = (props) => (
    <div>
      {(props.format === 'bin') ? (
        <input type="button" name="download" id={props._id} value="&#x2316;" onClick={start} />
      ) : null}
    </div>
  );
  const editing = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: false,
    mode: 'Dialog',
  };
  const editingMobile = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Normal',
  };
  const skus = [
    { value: 'ZH2506-01', text: 'ZH2506-01' },
    { value: 'h2s', text: 'H2S' },
  ];
  const fmtParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: fmtData,
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  const statusParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: statusData,
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  const grid = useRef(null);
  const clickHandler = (args) => {
    if (!grid || !grid.current) {
      return;
    }
    if (args.item.id.includes('delete')) { // Detect delete button click
      // Stop the default grid delete dialog
      args.cancel = true;
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords.length === 1) {
        const orgs = [];
        const result = data.ota.find((element) => element.filesid === selectedRecords[0].filesid);
        if (result) {
          data.organization.forEach((o) => {
            if (o.ota === result._id) {
              orgs.push(o.title);
            }
          });
        }
        if (orgs.length > 0) {
          DialogUtility.alert(`${selectedRecords[0].name} is being used by ${orgs}`);
          return;
        }
        // Create a custom confirmation dialog
        const dialogObj = DialogUtility.confirm({
          title: `Confirm Deletion of ${selectedRecords[0].name}`, // Custom Header
          content: 'Are you sure you want to permanently remove this record?',
          okButton: {
            text: 'Delete',
            click: () => {
              grid.current.deleteRecord(selectedRecords[0]); // Programmatically delete
              dialogObj.hide();
            },
          },
          cancelButton: { text: 'Cancel', click: () => dialogObj.hide() },
          showCloseIcon: true,
        });
      }
    }
  };

  const actionBegin = (args) => {
    if (!grid || !grid.current.columns) {
      return;
    }
    // Example of finding a button and modifying its style (after rendering)
    const cols = grid.current.columns;
    for (const col of cols) {
      if (col.headerText === 'Media' && (args.requestType === 'add' || args.requestType === 'beginEdit')) {
        col.visible = false;
        col.allowEditing = false;
      } else if (col.headerText === 'ID' && (args.requestType === 'add' || args.requestType === 'beginEdit')) {
        col.visible = false;
        col.allowEditing = false;
      } else {
        col.visible = true;
      }
    }
  };
  const actionComplete = (args) => {
    if (args.requestType === 'beginEdit') {
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.header = `Details of ${args.rowData.name}`;
      }
    }

    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data && args.data.name) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });
        fmtData.forEach((element) => {
          if (element.value == args.data.format) {
            element.format = element.id;
          }
        });
        fetch(`${REACT_APP_API_ENDPOINT}/otas`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
              // args.data.filesid = 'placeholder';
              if (grid && grid.current) {
                // window.location.reload();
              }
            }
            setReload(new Date().getTime());
          })
          .catch(() => {
            dialogClick('na', 'OTA PlaceHolder', 'An error has occured during Creation!', null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });
        fmtData.forEach((element) => {
          if (element.value == args.data.format) {
            element.format = element.id;
          }
        });
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/otas`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
          })
          .catch(() => {
          });
      }
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/otas`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
          })
          .catch(() => {
            dialogClick('na', 'OTA Delete', 'An error has occured during Removal!', null);
            args.cancel = true;
          });
      } else {
        args.cancel = false;
      }
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  data.organization.forEach((org) => {
    orgData.push({ id: org._id, value: org.title });
  });
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };

  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <Header category="" title="OTA" />
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={otas}
              width="auto"
              allowPaging
              allowSorting
              editSettings={isMobile ? editing : editing}
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              actionComplete={actionComplete}
              actionBegin={actionBegin}
              selectionSettings={selectionSettings}
              enableHover={false}
              pageSettings={{ pageSize: 25, pageCount: 10 }}
              allowResizing
              allowFiltering
              allowTextWrap
              ref={grid}
              enableAdaptiveUI={false}
              adaptiveUIMode="Both"
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  template={otaTemplate}
                  width="100"
                  visible
                  isPrimaryKey
                  allowEditing={false}
                />
                <ColumnDirective
                  field="name"
                  headerText="Name"
                  width="150"
                  validationRules={valuerules}
                  visible
                />
                <ColumnDirective
                  field="format"
                  headerText="Format"
                  width="80"
                  validationRules={valuerules}
                  visible
                  editType="dropdownedit"
                  edit={fmtParams}
                  foreignKeyField="id"
                  foreignKeyValue="value"
                  dataSource={fmtParams.params.dataSource}
                />
                <ColumnDirective
                  field="sku"
                  headerText="SKU"
                  width="80"
                  visible
                  editType="dropdownedit"
                  foreignKeyField="value"
                  foreignKeyValue="text"
                  dataSource={skus}
                />
                <ColumnDirective
                  field="status"
                  headerText="Status"
                  width="80"
                  validationRules={valuerules}
                  visible
                  editType="dropdownedit"
                  edit={statusParams}
                  foreignKeyField="id"
                  foreignKeyValue="value"
                  dataSource={statusParams.params.dataSource}
                />
                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="150"
                  textAlign="Center"
                  editType="dropdownedit"
                  edit={organizations}
                  validationRules={valuerules}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  dataSource={organizations.params.dataSource}
                />
                <ColumnDirective
                  field="filesid"
                  headerText="Media"
                  width="150"
                  visible
                  template={gridOTAProfile}
                  headerTemplate={gridOTAHeader}
                  allowEditing={false}
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, Resize, ForeignKey]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OTA;
